module.exports = __webpack_public_path__ + "img/channel_category.b78e982d.png";